import { Outlet, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Header from "../components/Header";

function ClientLayout() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [showTop, setShowTop] = useState(false); // ✅ ADD

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  // ✅ ADD YE EFFECT
  useEffect(() => {
    const handleScroll = () => {
      setShowTop(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Header />
      <Navbar />

      {loading ? (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "70vh", gap: "16px" }}>
          <div style={{ width: "48px", height: "48px", border: "4px solid #f0f0f0", borderTop: "4px solid var(--button-color)", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
          <p style={{ color: "#888", fontSize: "14px", margin: 0 }}>Loading...</p>
          <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        </div>
      ) : (
        <Outlet />
      )}

      <Footer />

      {/* ✅ SCROLL TO TOP BUTTON */}
      {showTop && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            width: "44px",
            height: "44px",
            borderRadius: "50%",
            background: "#07470c",
            color: "#fff",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
            zIndex: 9999,
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            display:"flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          ↑
        </button>
      )}
    </>
  );
}

export default ClientLayout;